<template>
	<div class="post-page-container page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<v-skeleton-loader
				v-if="this.isLoading"
				v-bind="attrs"
				type="card"
			/>

			<Event v-else-if="this.event" :event="this.event" />
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Event from '@/components/Event/Event'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import Dwh from '@/mixins/Dwh'

export default {
	name: 'EventPage',
	mixins: [Block, Dwh],
	components: {
		Event,
		PageBlocked
	},
	data() {
		return {
			attrs: {
				elevation: 0,
				class: 'pt-7',
			},
			successMessage: '',
			pageBlockedName: 'events'
		}
	},
	computed: {
		...mapGetters('event', ['event', 'isLoading']),
	},
	methods: {
		...mapActions('event', ['getEvent'])
	},
	watch: {
		event(newValue, oldValue) {
			if (newValue && !oldValue) {
				const triggerPayload = {
					category: 'Content',
					action: 'view_event_details',
					module: 'Events',
					data: newValue.event_id
				}

				if (newValue.chapter_id) {
					triggerPayload.content_chapter_id = [newValue.chapter_id]
				}

				this.sendTrigger(triggerPayload)
			}
		}
	},
	created() {
		if (this.$route.params.id !== undefined && (!this.isBlocked || this.isBlocked === null)) {
			this.getEvent(this.$route.params.id)
		}
	},
}
</script>

<style lang="scss">
.event-page-container{
	max-width: 600px;
	width: 100%;
}
.post-page {
	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}
}
</style>
